import { defineStore } from 'pinia'
import { computed } from 'vue'
import { fetchItems } from '@/api/verticals'
import { IVertical } from '@/interfaces/verticals'
import useCrudStore from '@/hooks/useCrudStore'

export const useVerticalsStore = defineStore('verticals', () => {
  const { items, GetItems } = useCrudStore({
    fetchItems
  })

  const sorted = computed(() => {
    return Object.values(items.value).sort((a, b) => {
      const nameA = a.attributes.title || ''
      const nameB = b.attributes.title || ''
      return nameA.localeCompare(nameB)
    })
  })

  const forSelector = computed(() => {
    const verticals = sorted.value as IVertical[]
    return verticals.map<VerticalEntry>((vertical: IVertical) => {
      return {
        id: vertical.id,
        title: vertical.attributes.title,
        disabled: false
      }
    })
  })

  return {
    GetItems,

    forSelector
  }
})

type VerticalEntry = {
  id: string
  title: string
  disabled: boolean
}
